/* eslint-disable array-callback-return */
import { withShortcut } from 'react-keybind';
import styled from 'styled-components';
import { Modal, Row, Col, Tag, Space } from 'antd';
import React, { useCallback, useEffect, useState } from 'react';
import { getTypeFromQuestion } from './SectionComponent';

const SurveyQuizShortcuts = props => {
  // eslint-disable-next-line no-unused-vars
  const { onNext, onPrev, setValueFromShortcut, currentMatrixQuestion, visible, setVisible } = props;
  const ref = React.useRef();

  // eslint-disable-next-line no-unused-vars
  const [state, setState] = useState({
    isSaved: false,
    totalFiles: 0
  });

  const next = useCallback(
    e => {
      e.preventDefault();
      console.info('Going next...');
      onNext();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [state]
  );
  const prev = useCallback(
    e => {
      e.preventDefault();
      console.info('Going prev...');
      onPrev();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [state]
  );

  const onKeyA = e => {
    e.preventDefault();
    console.info('Selecting A...');
    setValueFromShortcut('a');
  };
  const onKeyB = useCallback(
    e => {
      e.preventDefault();
      console.info('Selecting B...');
      setValueFromShortcut('b');
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [state]
  );
  const onKeyC = useCallback(
    e => {
      e.preventDefault();
      console.info('Selecting C...');
      setValueFromShortcut('c');
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [state]
  );
  const onKeyD = useCallback(
    e => {
      e.preventDefault();
      console.info('Selecting D...');
      setValueFromShortcut('d');
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [state]
  );
  const onKeyE = useCallback(
    e => {
      e.preventDefault();
      console.info('Selecting E...');
      setValueFromShortcut('e');
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [state]
  );
  const onKeyF = useCallback(
    e => {
      e.preventDefault();
      console.info('Selecting F...');
      setValueFromShortcut('f');
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [state]
  );
  const onKeyG = useCallback(
    e => {
      e.preventDefault();
      console.info('Selecting G...');
      setValueFromShortcut('g');
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [state]
  );
  const onKeyH = useCallback(
    e => {
      e.preventDefault();
      console.info('Selecting H...');
      setValueFromShortcut('h');
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [state]
  );
  const onKeyI = useCallback(
    e => {
      e.preventDefault();
      console.info('Selecting I...');
      setValueFromShortcut('i');
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [state]
  );
  const onKeyJ = useCallback(
    e => {
      e.preventDefault();
      console.info('Selecting J...');
      setValueFromShortcut('j');
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [state]
  );
  const onKeyK = useCallback(
    e => {
      e.preventDefault();
      console.info('Selecting K...');
      setValueFromShortcut('k');
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [state]
  );
  const onKeyL = useCallback(
    e => {
      e.preventDefault();
      console.info('Selecting L...');
      setValueFromShortcut('l');
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [state]
  );
  const onKeyM = useCallback(
    e => {
      e.preventDefault();
      console.info('Selecting M...');
      setValueFromShortcut('m');
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [state]
  );
  const onKeyN = useCallback(
    e => {
      e.preventDefault();
      console.info('Selecting N...');
      setValueFromShortcut('n');
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [state]
  );
  const onKeyO = useCallback(
    e => {
      e.preventDefault();
      console.info('Selecting O...');
      setValueFromShortcut('o');
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [state]
  );
  const onKeyP = useCallback(
    e => {
      e.preventDefault();
      console.info('Selecting P...');
      setValueFromShortcut('p');
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [state]
  );
  const onKeyQ = useCallback(
    e => {
      e.preventDefault();
      console.info('Selecting Q...');
      setValueFromShortcut('q');
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [state]
  );
  const onKeyR = useCallback(
    e => {
      e.preventDefault();
      console.info('Selecting R...');
      setValueFromShortcut('r');
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [state]
  );
  const onKeyS = useCallback(
    e => {
      e.preventDefault();
      console.info('Selecting S...');
      setValueFromShortcut('s');
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [state]
  );
  const onKeyT = useCallback(
    e => {
      e.preventDefault();
      console.info('Selecting T...');
      setValueFromShortcut('t');
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [state]
  );
  const onKeyU = useCallback(
    e => {
      e.preventDefault();
      console.info('Selecting U...');
      setValueFromShortcut('u');
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [state]
  );
  const onKeyV = useCallback(
    e => {
      e.preventDefault();
      console.info('Selecting V...');
      setValueFromShortcut('v');
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [state]
  );
  const onKeyW = useCallback(
    e => {
      e.preventDefault();
      console.info('Selecting W...');
      setValueFromShortcut('w');
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [state]
  );
  const onKeyX = useCallback(
    e => {
      e.preventDefault();
      console.info('Selecting X...');
      setValueFromShortcut('x');
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [state]
  );
  const onKeyY = useCallback(
    e => {
      e.preventDefault();
      console.info('Selecting Y...');
      setValueFromShortcut('y');
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [state]
  );
  const onKeyZ = useCallback(
    e => {
      e.preventDefault();
      console.info('Selecting Z...');
      setValueFromShortcut('z');
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [state]
  );

  const onVisibility = useCallback(
    e => {
      e.preventDefault();
      console.info('Showing shortcut list...');
      const visiblity = ref.current.innerHTML === 'true' ? true : false;
      setVisible(!visiblity);
      ref.current.innerHTML = !visiblity;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [state]
  );

  useEffect(() => {
    const { shortcut } = props;

    shortcut.registerShortcut(prev, ['ArrowUp'], 'Previous', 'Go previous step.');
    shortcut.registerShortcut(next, ['ArrowDown'], 'Next', 'Go next step');

    shortcut.registerShortcut(onKeyA, ['a'], 'Option A', 'Selects option A');
    shortcut.registerShortcut(onKeyB, ['b'], 'Option B', 'Selects option B');
    shortcut.registerShortcut(onKeyC, ['c'], 'Option C', 'Selects option C');
    shortcut.registerShortcut(onKeyD, ['d'], 'Option D', 'Selects option D');
    shortcut.registerShortcut(onKeyE, ['e'], 'Option E', 'Selects option E');
    shortcut.registerShortcut(onKeyF, ['f'], 'Option F', 'Selects option F');
    shortcut.registerShortcut(onKeyG, ['g'], 'Option G', 'Selects option G');
    shortcut.registerShortcut(onKeyH, ['h'], 'Option H', 'Selects option H');
    shortcut.registerShortcut(onKeyI, ['i'], 'Option I', 'Selects option I');
    shortcut.registerShortcut(onKeyJ, ['j'], 'Option J', 'Selects option J');
    shortcut.registerShortcut(onKeyK, ['k'], 'Option K', 'Selects option K');
    shortcut.registerShortcut(onKeyL, ['l'], 'Option L', 'Selects option L');
    shortcut.registerShortcut(onKeyM, ['m'], 'Option M', 'Selects option M');
    shortcut.registerShortcut(onKeyN, ['n'], 'Option N', 'Selects option N');
    shortcut.registerShortcut(onKeyO, ['o'], 'Option O', 'Selects option O');
    shortcut.registerShortcut(onKeyP, ['p'], 'Option P', 'Selects option P');
    shortcut.registerShortcut(onKeyQ, ['q'], 'Option Q', 'Selects option Q');
    shortcut.registerShortcut(onKeyR, ['r'], 'Option R', 'Selects option R');
    shortcut.registerShortcut(onKeyS, ['s'], 'Option S', 'Selects option S');
    shortcut.registerShortcut(onKeyT, ['t'], 'Option T', 'Selects option T');
    shortcut.registerShortcut(onKeyU, ['u'], 'Option U', 'Selects option U');
    shortcut.registerShortcut(onKeyV, ['v'], 'Option V', 'Selects option V');
    shortcut.registerShortcut(onKeyW, ['w'], 'Option W', 'Selects option W');
    shortcut.registerShortcut(onKeyX, ['x'], 'Option X', 'Selects option X');
    shortcut.registerShortcut(onKeyY, ['y'], 'Option Y', 'Selects option Y');
    shortcut.registerShortcut(onKeyZ, ['z'], 'Option Z', 'Selects option Z');

    shortcut.registerShortcut(onVisibility, ['ctrl+/'], 'Shortcut list', 'Show all the shortcuts list');
    return () => {
      const { shortcut } = props;

      shortcut.unregisterShortcut(['ArrowUp']);
      shortcut.unregisterShortcut(['ArrowDown']);

      shortcut.unregisterShortcut(['a']);
      shortcut.unregisterShortcut(['b']);
      shortcut.unregisterShortcut(['c']);
      shortcut.unregisterShortcut(['d']);
      shortcut.unregisterShortcut(['e']);
      shortcut.unregisterShortcut(['f']);
      shortcut.unregisterShortcut(['g']);
      shortcut.unregisterShortcut(['h']);
      shortcut.unregisterShortcut(['i']);
      shortcut.unregisterShortcut(['j']);
      shortcut.unregisterShortcut(['k']);
      shortcut.unregisterShortcut(['l']);
      shortcut.unregisterShortcut(['m']);
      shortcut.unregisterShortcut(['n']);
      shortcut.unregisterShortcut(['o']);
      shortcut.unregisterShortcut(['p']);
      shortcut.unregisterShortcut(['q']);
      shortcut.unregisterShortcut(['r']);
      shortcut.unregisterShortcut(['s']);
      shortcut.unregisterShortcut(['t']);
      shortcut.unregisterShortcut(['u']);
      shortcut.unregisterShortcut(['v']);
      shortcut.unregisterShortcut(['w']);
      shortcut.unregisterShortcut(['x']);
      shortcut.unregisterShortcut(['y']);
      shortcut.unregisterShortcut(['z']);

      shortcut.unregisterShortcut(['ctrl+/']);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <span ref={ref} id="shortcut-visible" style={{ display: 'none' }}>
        false
      </span>
      <Modal visible={visible} footer={null} onOk={() => setVisible(false)} onCancel={() => setVisible(false)} centered>
        <Row justify="space-between">
          <Col>
            <h3>Keyboard shortcut</h3>
          </Col>
          <Col>
            <Tag>Ctrl + /</Tag>
            &nbsp; &nbsp;
          </Col>
        </Row>
        <br />
        <h4>Navigation</h4>
        <Row justify="space-between">
          <Col>Previous Question</Col>
          <Col>
            <Space>
              <Tag>&uarr;</Tag>
            </Space>
          </Col>
        </Row>
        <Smbr />
        <Row justify="space-between">
          <Col>Next Question</Col>
          <Col>
            <Space>
              <Tag>&darr;</Tag>
            </Space>
          </Col>
        </Row>
        <br />
        <h4>Question with options</h4>
        <Row justify="space-between">
          <Col>Selecting option a</Col>
          <Col>
            <Tag>a</Tag>
          </Col>
        </Row>
        <Smbr />
        <Row justify="space-between">
          <Col>Selecting option b</Col>
          <Tag>b</Tag>
        </Row>
        <Smbr />
        <Row justify="space-between">
          <Col>Selecting option c</Col>
          <Col>
            <Tag>c</Tag>
          </Col>
        </Row>
        <Smbr />
        <Row justify="space-between">
          <Col>Selecting option d</Col>
          <Col>
            <Tag>d</Tag>
          </Col>
        </Row>
        <Row justify="space-between">
          <Col>and so on...</Col>
        </Row>
      </Modal>
    </>
  );
};

// Wrap all components that need shortcut capabilities with the "withShortcut" HOC
export default withShortcut(SurveyQuizShortcuts);

export function getShortCutObj(question) {
  const obj = {};
  if (question?.choiceSet?.edges?.length)
    question.choiceSet.edges.map(({ node }, idx) => {
      obj[String.fromCharCode(97 + idx)] = node?.value;
    });

  return {
    name: question?.id,
    type: getTypeFromQuestion(question),
    ...obj
  };
}
const Smbr = styled.div`
  margin-top: 8px;
`;
